import { Button, IButtonProps } from 'components/admin/ui/Button';
import { Download03 } from 'ethena-icons';
import _ from 'lodash';
import { PopulationCsvDownloadTrigger as Trigger } from './PopulationCsvDownloadTrigger';
import {
  CustomPopulationCsvDownloadProps,
  DefaultPopulationCsvDownloadProps,
  PopulationCsvDownloadProps,
} from './types';

type ButtonProps = Omit<IButtonProps, 'onClick'>;

type PopulationCsvDownloadButtonProps = PopulationCsvDownloadProps &
  ButtonProps;

export const PopulationCsvDownloadButton = ({
  fallbackFilename = 'population.csv',
  ...rest
}: PopulationCsvDownloadButtonProps) => {
  const triggerProps =
    rest.mode === 'default'
      ? ({
          mode: rest.mode,
          searchParams: rest.searchParams,
        } as DefaultPopulationCsvDownloadProps)
      : ({
          mode: rest.mode,
          getCsvData: rest.getCsvData,
        } as CustomPopulationCsvDownloadProps);

  const { className, ...buttonProps } = _.omit(rest, _.keys(triggerProps));

  return (
    <Trigger fallbackFilename={fallbackFilename} {...triggerProps}>
      <Button
        className={className}
        color="blue"
        icon={Download03}
        variant="outline-light"
        {...buttonProps}
      >
        Download CSV
      </Button>
    </Trigger>
  );
};
